import { DeployDialog, DeployDialogProps } from "./deploy-dialog";

/**
 * Going back is repointing the campaign, so it is the deploy dialog in rollback mode:
 * same in-flight choice with `pin` by default, no scenario requirement, and a trace.
 * Sharing the body is what keeps the two screens from drifting apart.
 */
export function RollbackDialog(props: Omit<DeployDialogProps, "mode">) {
    return <DeployDialog {...props} mode="rollback" />;
}
